import { generateId } from 'common/utils/string';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import ParseExcel, { ParseExcelProps } from '.';
import notification from '../notification';

export type PassportType = {
  id: string;
  passportImagePath: string;
  documentNo: string;
  personalNo: string;
  nativeName: string;
  familyName: string;
  givenName: string;
  sex: string;
  birthday: Date;
  birthPlace: string;
  expireDate: Date;
  nationality: string;
  issueState: string;
  roomNo: string;
  chkinDate: Date;
};

export type IdentityCardType = {
  id: string;
  ididImagePath: string;
  faceImage: string;
  identityNumber: string;
  name: string;
  birthPlace: string;
  birthday: string;
  sex: string;
  blood: string;
  address: string;
  no: string;
  village: string;
  area: string;
  religion: string;
  marital: string;
  job: string;
  nationality: string;
  expiryDate: string;
  roomNo: string;
  chkinDate: string;
};

interface Props extends Omit<ParseExcelProps, 'onClick'> {
  onResult: (result: PassportType[] | IdentityCardType[]) => void;
  type?: 'passport' | 'idid';
}

function convertValue(value: string) {
  return value.replaceAll('="', '').replaceAll('"', '');
}

function convertDateValue(value: string) {
  const split = value.split(' ');
  const date = split[0].split('/').reverse().join('/');
  return new Date(`${date}${split[1] ? ` ${split[1]}` : ''}`);
}

export default function ParsePassport(props: Props) {
  const { type = 'passport' } = props;
  const { t } = useTranslation();
  return (
    <ParseExcel
      text={props.text}
      style={props.style}
      onClick={(result) => {
        try {
          if (type === 'idid') {
            const data: IdentityCardType[] = result.data
              .filter((_, idx) => idx !== 0)
              .map((item) => ({
                id: generateId(),
                ididImagePath: convertValue(item[0]),
                faceImage: convertValue(item[1]),
                identityNumber: convertValue(item[2]),
                name: convertValue(item[3]),
                birthPlace: convertValue(item[4]),
                birthday: convertValue(item[5]),
                sex: convertValue(item[6]),
                blood: convertValue(item[7]),
                address: convertValue(item[8]),
                no: convertValue(item[9]),
                village: convertValue(item[10]),
                area: convertValue(item[11]),
                religion: convertValue(item[12]),
                marital: convertValue(item[13]),
                job: convertValue(item[14]),
                nationality: convertValue(item[15]),
                expiryDate: convertValue(item[16]),
                roomNo: convertValue(item[17]),
                chkinDate: convertValue(item[18]),
              }));
            props.onResult(data);
            return;
          }

          const data: PassportType[] = result.data
            .filter((_, idx) => idx !== 0)
            .map((item) => ({
              id: generateId(),
              passportImagePath: convertValue(item[0]),
              documentNo: convertValue(item[1]),
              personalNo: convertValue(item[2]),
              nativeName: convertValue(item[3]),
              familyName: convertValue(item[4]),
              givenName: convertValue(item[5]),
              sex: convertValue(item[6]),
              birthday: convertDateValue(convertValue(item[7])),
              birthPlace: convertValue(item[8]),
              expireDate: convertDateValue(convertValue(item[9])),
              nationality: convertValue(item[10]),
              issueState: convertValue(item[11]),
              roomNo: convertValue(item[12]),
              chkinDate: convertDateValue(convertValue(item[13])),
            }));
          props.onResult(data);
        } catch (error) {
          console.error(error);
          notification.error({ message: t('common:invalid_data') });
        }
      }}
    />
  );
}
